import { Dialogs } from '@leverege/ui-elements';
import { Context, Config } from '@leverege/plugin';
import { AllowedReducer } from '@leverege/api-redux';
import { GlobalState } from '@leverege/ui-redux';
import { Attributes } from '@leverege/ui-attributes';
import ReconcileSalesDialog from './ReconcileSalesDialog';
import RecovrSales from '../../util/RecovrSales';
export default {
  id: 'recovr.sales.reconcileSales',
  name: 'Reconcile Sale',
  matches: [{
    use: ['contextMenu', 'mobileActionBar'],
    path: ['sale', 'company.locations.sales'],
    objectType: 'sale'
  }, {
    use: ['contextMenu', 'mobileActionBar'],
    path: ['sale', 'company.sales'],
    objectType: 'sale'
  }, {
    use: ['contextMenu', 'mobileActionBar'],
    path: ['sale', 'location.sales'],
    objectType: 'sale'
  }],
  appearance: ({
    context
  }) => {
    const targets = context?.target || [];
    const title = targets.length > 1 ? `Reconcile ${targets.length} Sales` : 'Reconcile Sale';
    return {
      icon: Config.get('ReconcileSales', 'icon', 'https://storage.googleapis.com/recovr-ui-assets/icon-memo-check.svg'),
      name: Config.get('ReconcileSales', 'title', title)
    };
  },
  // calls test api call to check for permissions
  prepare: async cxt => {
    const targets = Context.getTargetsOfType(cxt, 'sale');
    if (targets?.length === 0 || targets == null) {
      return false;
    }
    const companyId = targets[0]?.data?.data?.company?.id;
    const locationId = targets[0]?.data?.data?.location?.id;
    const saleId = targets[0]?.id;
    return RecovrSales.canReconcileSales({
      companyId,
      locationId,
      saleId,
      reconcileState: 'notReconciled'
    });
  },
  // waits for permissions object from prepare to return true
  isPrepared: cxt => {
    const targets = Context.getTargetsOfType(cxt, 'sale');
    if (targets?.length === 0 || targets == null) {
      return true;
    }
    const a = AllowedReducer.get(GlobalState.get(), targets[0]?.id);
    return a.reconcileSales != null;
  },
  // if isPrepared returns true, perform action
  handles: cxt => {
    const targets = Context.getTargetsOfType(cxt, 'sale');
    if (targets?.length === 0 || targets == null) {
      return false;
    }
    const a = AllowedReducer.get(GlobalState.get(), targets[0].id);
    const hasKeysOnly = targets.some(tgt => {
      return !Attributes.get('sale.productTypes.recovr', tgt.type, tgt.data) && Attributes.get('sale.productTypes.recovrKeys', tgt.type, tgt.data);
    });
    return !hasKeysOnly && a.reconcileSales === true;
  },
  perform: async props => {
    const {
      context
    } = props;
    const {
      clientProps
    } = context;
    const sales = Context.getTargetsOfType(context, 'sale');
    Dialogs.show({
      id: 'reconcileSales',
      component: ReconcileSalesDialog,
      props: {
        context,
        sales,
        reloadData: context.reloadData || clientProps.reloadData
      }
    });
  }
};